import React, { useEffect, useState } from "react";

const ProjectMembers = ({ projectId, refreshKey }) => {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const authToken = localStorage.getItem("auth_token");

    fetch(`https://loopsneller.com/api/projects/${projectId}/members`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch project members");
        }
        return response.json();
      })
      .then((data) => {
        setMembers(data);
        setLoading(false);
      })
      .catch((error) => {
        setError(error.message);
        setLoading(false);
      });
  }, [projectId, refreshKey]);

  if (loading)
    return <p className="text-center text-muted mt-3">Loading members...</p>;
  if (error)
    return <p className="text-danger text-center mt-3">Error: {error}</p>;

  return (
    <div className="card mt-4 shadow-sm">
      <div className="card-header text-black d-flex align-items-center">
        <i className="bi bi-people me-2"></i>
        <h5 className="mb-0">Project Members</h5>
      </div>
      <div className="card-body">
        {members.length === 0 ? (
          <p className="text-muted text-center">
            No members assigned to this project.
          </p>
        ) : (
          <table className="table align-middle">
            <thead className="table-light">
              <tr>
                <th>Member</th>
                <th className="text-center">Role</th>
              </tr>
            </thead>
            <tbody>
              {members.map((member) => (
                <tr key={member.id}>
                  <td>
                    <i className="bi bi-person-circle text-primary me-2"></i>
                    {member.user.name}
                  </td>
                  <td className="text-center">
                    <span
                      className={`badge rounded-pill ${
                        member.role === "Admin"
                          ? "bg-danger"
                          : member.role === "Manager"
                          ? "bg-warning text-dark"
                          : "bg-secondary"
                      }`}
                    >
                      {member.role}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default ProjectMembers;
